export default "__VITE_ASSET__jVjat1AJ__"